import {useMemo} from "react";

import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {ISmsLoginSendResult} from "../../../auth/api/sms_login";
import {PromotionSmsLoginProvider} from "../../../auth/providers/PromotionSmsLoginProvider";

const SMS_LOGIN_STORAGE_KEY_NAMESPACE = "promotionSmsLogin";

interface IProps {
    email: string;
    phone: string;
    initialSendResult: ISmsLoginSendResult;
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    onInitRejected: (error: {message: string; status: number}) => void;
}

export const PromotionLeadSmsLoginVerification = (props: IProps) => {
    const {email, phone, initialSendResult, isOpen, onClose, onSuccess, onChangeNumber, onInitRejected} = props;
    const credentials = useMemo(() => ({email, phone}), [email, phone]);

    return (
        <PromotionSmsLoginProvider credentials={credentials} initialSendResult={initialSendResult} onInitRejected={onInitRejected}>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={onClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                phoneNumber={phone}
                storageKeyNamespace={SMS_LOGIN_STORAGE_KEY_NAMESPACE}
                allowResendAfterTooManyRequests
                restartCooldownOnOpen
            />
        </PromotionSmsLoginProvider>
    );
};
import {useMemo} from "react";

import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {ISmsLoginSendResult} from "../../../auth/api/sms_login";
import {PromotionSmsLoginProvider} from "../../../auth/providers/PromotionSmsLoginProvider";

const SMS_LOGIN_STORAGE_KEY_NAMESPACE = "promotionSmsLogin";

interface IProps {
    email: string;
    phone: string;
    initialSendResult: ISmsLoginSendResult;
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    onInitRejected: (error: {message: string; status: number}) => void;
}

export const PromotionLeadSmsLoginVerification = (props: IProps) => {
    const {email, phone, initialSendResult, isOpen, onClose, onSuccess, onChangeNumber, onInitRejected} = props;
    const credentials = useMemo(() => ({email, phone}), [email, phone]);

    return (
        <PromotionSmsLoginProvider credentials={credentials} initialSendResult={initialSendResult} onInitRejected={onInitRejected}>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={onClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                phoneNumber={phone}
                storageKeyNamespace={SMS_LOGIN_STORAGE_KEY_NAMESPACE}
                allowResendAfterTooManyRequests
                restartCooldownOnOpen
            />
        </PromotionSmsLoginProvider>
    );
};
